import { Region, WithRef } from '@principle-theorem/shared';
import { type IContactDetails } from '../../contact/contact';
import { IPatientForm } from '../../custom-forms/patient-form';
import { SmsIntegrationOption } from '../../interaction/sms-integration';
import {
  IBasePatient,
  IPatientContactDetails,
  type IPatient,
} from '../../patient/patient';
import { type ITemplateContext, type ITemplateScopeData } from '../templating';
import { type IBaseTemplateContext } from './base-context';
import {
  IPracticeScopeData,
  IPracticeTemplateContext,
} from './practice-context';

export interface IPatientScopeData
  extends ITemplateScopeData,
    IPracticeScopeData {
  patient: WithRef<IPatient>;
  medicalHistoryLink: string;
  patientFormsLink: string;
  appointmentBookingLink: string;
  unsubscribeLink: string;
  patientForms: WithRef<IPatientForm>[];
  region: Region;
  smsIntegration?: SmsIntegrationOption;
  primaryContact?: WithRef<IBasePatient & IPatientContactDetails>;
  referrer?: Partial<IContactDetails>;
}

export interface IPatientTemplateContext
  extends ITemplateContext,
    IPracticeTemplateContext,
    IBaseTemplateContext {
  patientEmail: string;
  patientFullName: string;
  patientFirstName: string;
  patientPreferredName: string;
  patientLastName: string;
  patientMobile: string;
  patientDateOfBirth: string;
  patientAddress: string;
  patientMedicareNumber: string;
  referrerName: string;
  referrerEmail: string;
  referrerAddress: string;
  referrerJobTitle: string;
  medicalHistoryLink: string;
  patientFormsLink: string;
  appointmentBookingLink: string;
  unsubscribeLink: string;
}
